module.exports = __webpack_public_path__ + "images/emoji/book.d657f1ce7e240aeb3a11.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/book.png
// module id = NukN
// module chunks = 2